import { render, staticRenderFns } from "./SetupPasswordView.vue?vue&type=template&id=50dde386&"
import script from "./SetupPasswordView.vue?vue&type=script&lang=js&"
export * from "./SetupPasswordView.vue?vue&type=script&lang=js&"
import style0 from "./SetupPasswordView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports